const CANCELLED = 'CANCELLED' || 'CANCELED'
const CANCEL_PROVIDER = 'CANCEL_PROVIDER'
const INVOICED = 'INVOICED'
const INVOICE_IN_PROGRESS = 'INVOICE_IN_PROGRESS'
const INVOICE_REQUESTED = 'INVOICE_REQUESTED'
const PROCESSING = 'PROCESSING'
const PARTIAL_REFUND = 'PARTIAL_REFUND'
const PENDING = 'PENDING'
const CONFIRM = 'CONFIRM'
const DELETED = 'DELETED'
const EXPIRED = 'EXPIRED'
const REFUND_IN_PROGRESS = 'REFUND_IN_PROGRESS '
const GUARANTEED = 'GUARANTEED'
const CONFIRMED = 'CONFIRMED'
const REJECTED = 'REJECTED'
const REFUNDED = 'REFUNDED'
const PENDING_BILLING = 'PENDING_BILLING'
const PAID = 'PAID'
const UNPAID = 'UNPAID'
const PENDING_RESERVATION = 'PENDING_RESERVATION'
const IN_REVIEW = 'IN_REVIEW'
const CREATED = 'CREATED'
const CANCELLATION_IN_PROGRESS = 'CANCELLATION_IN_PROGRESS'
const VOID_IN_PROGRESS = 'VOID_IN_PROGRESS'
const IN_PROCESS = 'IN_PROCESS'
const FINISHED = 'FINISHED'
const FINALIZED = 'FINALIZED'
const FAILED_INVOICED = 'FAILED_INVOICED'
const INVALIDATED = 'INVALIDATED'
const GENERATED = 'GENERATED'
const BILLED = 'BILLED'

export {
  CANCELLED,
  CANCEL_PROVIDER,
  INVOICED,
  INVOICE_IN_PROGRESS,
  INVOICE_REQUESTED,
  PROCESSING,
  PENDING,
  CONFIRM,
  EXPIRED,
  DELETED,
  PARTIAL_REFUND,
  REFUND_IN_PROGRESS,
  GUARANTEED,
  CONFIRMED,
  REJECTED,
  REFUNDED,
  PENDING_BILLING,
  PAID,
  UNPAID,
  IN_REVIEW,
  PENDING_RESERVATION,
  CREATED,
  CANCELLATION_IN_PROGRESS,
  VOID_IN_PROGRESS,
  IN_PROCESS,
  FINISHED,
  FINALIZED,
  FAILED_INVOICED,
  INVALIDATED,
  GENERATED,
  BILLED
}
